/**
 * Core Layer - RTC Enums and Constants
 * All enums and constants used across the RTC system
 */

export const screenOrientationEnum = {
    LANDSCAPE: 3,
    PORTRAIT: 1,
};

export const messageTypeEnum = {
    TEXT: 0,
    CAMERA_FEED: 1,
    MARKER: 2,
    DRAW_MARKER: 3,
    COMMAND: 4,
    HIGH_RES_FEED_SNAP: 5,
    REMOTE_PEER_SETTINGS: 6,
    CHAT_MESSAGE: 7,
    TRANSCRIPTION_MESSAGE: 10,
    MIC_STATE: 11,
    RSE_MAXIMIZED: 12,
    RECORDING_STARTED: 13,
    STOP_RECORDING: 14,
    RECORDING_STOPPED: 15,
    RECORDER_HEARTBEAT: 16,
    TRANSCRIPTION_REQUEST: 21,
    RECORDER_TAKEOVER: 22,
};

export const messageDataTypeEnum = {
    ATTACHED_PROCEDURE: "attached_procedure",
    TEXT: 'text',
    FILE: 'file',
};

export const commandTypeEnum = {
    CLEAR_ALL: 'Clear',
    CLEAR_LAST: 'ClearLast',
    FREEZE: 'Freeze',
};

export const toolsEnum = {
    DRAW: 'draw',
    BEACON: 'beacon',
    MARKER: 'marker',
};

export const markerTypeEnum = {
    DRAW: 3,
    BEACON: 1,
    ARROW: 0,
};

export const rtcSteps = {
    CHOOSE_CHANNEL: 'choose_channel',
    IOS_CHOOSE_CAMERA: 'ios_choose_camera',
    JOIN_ROOM: 'join_room',
    MEETING: 'meeting',
    AFTER_MEETING: 'after_meeting',
};

export const toolsColors = [
    'rgb(0,255,0)',
    'rgb(0,190,255)',
    'rgb(255,0,0)',
    'rgb(255,255,0)',
    'rgb(0,0,0)',
];

// Default camera dimensions
export const DEFAULT_CAMERA_WIDTH = 640;
export const DEFAULT_CAMERA_HEIGHT = 480;
export const DEFAULT_CAMERA_WIDTH_PORTRAIT = 480;
export const DEFAULT_CAMERA_HEIGHT_PORTRAIT = 640;

// Screen share dimensions
export const SCREEN_SHARE_WIDTH = 1280;
export const SCREEN_SHARE_HEIGHT = 720;

// Video encoding settings
export const DEFAULT_BITRATE = 1_500_000;
export const KEY_FRAME_INTERVAL = 150; // Send keyframe every 150 frames

// Audio settings
export const DEFAULT_SAMPLE_RATE = 48000;
export const AUDIO_BUFFER_SIZE = 16384;
export const NOISE_THRESHOLD = 0.05;

// Timeouts and intervals
export const HEARTBEAT_INTERVAL = 3000;
export const PING_INTERVAL = 15000;
export const ROOM_ACTIVITY_CHECK_INTERVAL = 1300;
export const PARTICIPANT_INACTIVE_THRESHOLD = 10000;
export const PARTICIPANT_REMOVE_THRESHOLD = 40000;
export const VIDEO_INACTIVE_THRESHOLD = 1300;
export const AUDIO_INACTIVE_THRESHOLD = 1300;
export const RECORDING_STOP_THRESHOLD = 25000;
export const RECORDING_STOPPING_TIMEOUT = 15000;
export const RECORDING_INITIALIZING_TIMEOUT = 15000;
export const TRANSCRIPTION_MESSAGE_LIFETIME = 10000;
// Connection retry settings
export const MAX_RETRIES = 5;
export const BASE_RETRY_DELAY = 1000;
